import request from '@/axios/request'
import type { AxiosRequestConfig } from 'axios'
import { DeepRequired } from '../interface'
/**
 * 获取课班关联的课程课时列表
 * @param {string} scheduleClassesId 课班标识
 * @returns
 */
export function getCourseTimesByScheduleClassesId(scheduleClassesId: number) {
  return request.get<DeepRequired<GetCourseTimesByScheduleClassesIdRes>>(
    `/qedu/org/scheduleClasses/getCourseTimesByScheduleClassesId?scheduleClassesId=${scheduleClassesId}`
  )
}
// Response interface
export interface GetCourseTimesByScheduleClassesIdRes {
  /*状态码 */
  code: number

  /*返回消息 */
  msg: string

  /* */
  data: {
    /*课时列表:课时列表 */
    lstCourseTimes: {
      /*主键:主键 */
      id: number

      /*课程标识:课程标识 */
      courseId: number

      /*课次:课次 */
      times: number

      /*主题:主题 */
      topic: string

      /*创建人名称:创建人名称 */
      creator: string

      /*创建时间:创建时间 */
      createDate: string
    }[]

    /*课件列表:课件列表 */
    lstCourseTimeWare: {
      /*主键:主键 */
      id: string

      /*文件名称:文件名称 */
      fileName: string

      /*类型:类型 */
      fileType: string

      /*存储地址:存储地址 */
      string

      /*文件大小:文件大小 */
      size: string

      /*外键ID:外键ID */
      foreignKey: string

      /*业务类型:业务类型 */
      businessType: string

      /*业务类型名称:业务类型名称 */
      businessTypeName: string

      /*内容标识:内容标识 */
      businessCtxId: string

      /*内容名称:内容名称 */
      businessCtxName: string

      /*机构标识:机构标识 */
      orgId: number

      /*学校标识:学校标识 */
      schoolId: number

      /*创建人名称:创建人名称 */
      creator: string

      /*创建时间:创建时间 */
      createDate: string
    }[]
  }
}

// 按照时间搜索排课
export const getScheduleClassesByTime = (param) => {
  return request
    .get('/qedu/school/scheduleClasses/listByTimeAndStatus', { params: param })
    .then(({ data }) => data)
}

// ------------------------表格数据------------------
// 老师签到统计
export const getTeacherSigninInfo = (param) => {
  return request
    .get('/qedu/org/summary/getTeacherSigninInfo', { params: param })
    .then(({ data }) => data)
}

// 本学期数据统计
export const getTermInfo = (param) => {
  return request.get('/qedu/org/summary/getTermInfo', { params: param }).then(({ data }) => data)
}
// 今日数据量统计
export const getTodayInfo = (param) => {
  return request.get('/qedu/org/summary/getTodayInfo', { params: param }).then(({ data }) => data)
}

// 学校开班占比统计
export const getSchoolRate = (param) => {
  return request.get('/qedu/org/summary/getSchoolRate', { params: param }).then(({ data }) => data)
}

// 学生签到统计
export const getStudentSigninInfoVo = (param) => {
  return request
    .get('/qedu/org/summary/getStudentSigninInfoVo', { params: param })
    .then(({ data }) => data)
}
// 学校学生人数占比
export const getSchoolCourseClsRate = (param) => {
  return request
    .get('/qedu/org/summary/getSchoolCourseClsRate', { params: param })
    .then(({ data }) => data)
}

// 五育人数占比
export const getCourseClsRate = (param) => {
  return request
    .get('/qedu/org/summary/getCourseClsRate', { params: param })
    .then(({ data }) => data)
}

// 五育人数占比
export const getSchoolGradeSexRate = (param) => {
  return request
    .get('/qedu/org/summary/getSchoolGradeSexRate', { params: param })
    .then(({ data }) => data)
}
export const authActivity = (data) => {
  return request.post('/qedu/school/approvalRequests/authOrgTeacher', data)
}

export const saveTimes = (data) => {
  return request.post('/qedu/school/scheduleClasses/updateSchedule', data)
}

export const getScheduleClasses = () => {
  return request.get(`/qedu/school/scheduleClasses/listScheduleClassesAlreadyConfig`, {})
}

export const getScheduleClassesAll = (params) => {
  return request.get('/qedu/school/scheduleClasses/listScheduleClasses4Offer', { params })
}

export const getSelectedCourses = (params) => {
  return request.get('/qedu/school/selectedCourse/list', { params })
}

export const createClassV2 = (data) => {
  return request.post('/qedu/school/scheduleClasses/v2/createScheduleClasses', data)
}

export const deleteClassV2 = (id) => {
  return request.post(`/qedu/school/selectedCourse/remove/${id}`)
}

export const selectClassV2 = (data) => {
  return request.post('/qedu/school/courseSelection/selectCourse4School', null, {
    params: data
  })
}

/**
 * 自动生成排课时间
 * @param {string} startDay 开始时间 yyyy-MM-dd
 * @param {string} weekIdx 周几
 * @param {string} size 生成多少个日期(最多30个)
 * @returns
 */
export const generateTime = (startDay: string, weekIdx: number, size: number) => {
  return request.get('/qedu/school/scheduleClasses/autoGenerateDays', {
    params: {
      startDay,
      weekIdx,
      size
    }
  })
}

export const getShceduleClasses = ({
  beginDate,
  endDate
}: {
  beginDate: string
  endDate: string
}) => {
  return request.get('/qedu/school/scheduleClasses/listSchedule4Calendar', {
    params: {
      beginDate,
      endDate
    }
  })
}

// 注销登录
export const logout = () => {
  return request.post('/qedu/school/logout')
}

// 获取个人信息
export const getUserInfo = () => {
  return request.get('/qedu/school/profile/profile')
}

// 重置密码
export const resetPassword = (data) => {
  return request.put(
    '/qedu/school/profile/updatePwd',
    {},
    {
      params: data
    }
  )
}

// 导入
export const importData = (url: string, data: FormData) => {
  console.log(url, data)
  return request.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取当前学校所有年级
export const getSchoolGrades = () => {
  return request.get('/qedu/school/infoClass/list')
}

// 获取当前学校的老师
export const getSchoolTeachers = (params) => {
  return request.get('/qedu/school/infoTeacher/list', { params })
}

// 学校开创空白科班
export const createBlankClass = (data) => {
  return request.post('/qedu/school/scheduleClasses/v2/createSchoolSelfBuiltScheduleClasses', data)
}
